import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { SiGitbook } from "react-icons/si";
import { PiBookOpenText } from "react-icons/pi";
import { PiBookOpenUser } from "react-icons/pi";
import { LuBookOpen, LuBrain } from "react-icons/lu";
import { RiBookMarkedLine } from "react-icons/ri";
import { FaRegHeart } from "react-icons/fa";
import { FaCrown } from "react-icons/fa";
import { FaUser } from "react-icons/fa";
import PaywallModal from "../modals/PaywallModal";
import { useUserData } from "../../context/UserDataContext";
import OfflineBanner from "../modals/OfflineBanner";
import { ReactComponent as AprendoleIcon } from "../../icons/AprendoleIcon5.svg";
import "./BrandBanner.css";

import { logEvent } from "firebase/analytics";
import { analytics } from "../../firebase";

export default function BrandBanner() {
  const navigate = useNavigate();
  const location = useLocation();
  const [showPaywall, setShowPaywall] = useState(false);
  const { userData } = useUserData();
  const isPaidUser = userData?.hasAccess && userData?.subscriptionStatus === "active";


  const actions = [
    { id: "stories", label: "Histórias", icon: <LuBookOpen />, path: "/home" },
    { id: "flashcards", label: "Flashcards", icon: <LuBrain />, path: "/flashcards" },
    { id: "library", label: "Biblioteca", icon: <FaRegHeart />, path: "/library" },
    { id: "profile", label: "Perfil", icon: <FaUser />, path: "/profile" },
  ];

  return (
    <header className="brand-banner">
      <div className="brand-banner-container">
        <Link to="/home" replace className="brand-banner-logo">
          <AprendoleIcon className="brand-logo-icon" />
          <div className="brand-text">
            <h1 className="shiny-text-banner">Aprendole</h1>
          </div>
        </Link>

        <nav className="brand-banner-nav">
          {actions.map((a) => {
            const isActive = location.pathname === a.path;
            return (
              <button
                key={a.id}
                className={`brand-nav-item ${isActive ? "active" : ""}`}
                onClick={() => navigate(a.path, { replace: true })}
              >
                <span className="brand-nav-icon">{a.icon}</span>
                <span className="brand-nav-label">{a.label}</span>
              </button>
            );
          })}
        </nav>

        <div className="brand-banner-actions">
          {!isPaidUser ? (
            <button
              className="premium-btn"
              onClick={() => {
                if (analytics) {
                  logEvent(analytics, "paywall_viewed", { trigger: "premium_button" });
                }
                setShowPaywall(true);
              }}
            >
              Vire Premium
            </button>
          ) : (
            <button className="premium-btn premium-active" disabled>
              <FaCrown className="premium-icon" />
            </button>
          )}
        </div>

      </div>
      
        <OfflineBanner />

      {showPaywall && <PaywallModal onClose={() => setShowPaywall(false)} />}
    </header>
  );
}


